define([
	"dojo/_base/array",
	"csi/access/crews",
	"csi/action",
	"csi/locale",
	"csi/reflection",
	"csi/xml",
	"./POBackToDraft",
	"./PackList/GeneratePackListLabelFileAction"
], function(array, crews, csiAction, locale, reflection, xml) {

	csiAction.registerControllers("", {
		CancelPOApprovalWorkflow: "Workflow.UTCController",
		ForcePOApprove: "Workflow.UTCController"
	});

	return {
		CONFIG: "centric://REFLECTION/INSTANCE/SourcingModule/Configuration",

		// PurchasedOrder states
		poStateAbandoned: "Abandoned",
		poStateClosed: "Closed",
		poStateDraft: "Draft",
		poStateIssued: "Issued",
		poStateNegotiation: "Negotiation",
		poStateReady: "Ready",

		preActionShipmentFreeze: function(/*Controller*/ac) {
			var shipmentTerms = ac.getNode();
			if (!shipmentTerms.FreezeStatus && !shipmentTerms.ShipmentTermsProductShipments.length) {
				ac.m_error = locale.resource("ERROR_NO_SHIPMENT_PRODUCTS");
				ac.postProcess(false);
				return false;
			}

			return true;
		},

		canCreatePOByColor: function() {
			var rca = reflection.getClass("PurchasedOrder").getAttribute("OrdersByColor");
			return !rca.isReadOnly || !!rca.getValue();
		},

		onAccessActionPOBackToDraft: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getPOState(ctx.getNode());
			return state == this.poStateAbandoned;
		},

		onAccessActionPOBackToNegotiation: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getPOState(ctx.getNode());
			return state == this.poStateIssued || state == this.poStateReady;
		},

		onAccessActionPOClosedToDraft: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getPOState(ctx.getNode());
			return state == this.poStateClosed;
		},

		onAccessActionPOToAbandoned: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getPOState(ctx.getNode());
			return state == this.poStateDraft || state == this.poStateNegotiation;
		},

		onAccessActionPOToClosed: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getPOState(ctx.getNode());
			return state == this.poStateIssued;
		},

		onAccessActionPOToIssued: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getPOState(ctx.getNode());
			return state == this.poStateReady;
		},

		onAccessActionPOToNegotiation: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getPOState(ctx.getNode());
			return state == this.poStateDraft;
		},

		onAccessActionPOToReady: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getPOState(ctx.getNode());
			return state == this.poStateDraft || state == this.poStateNegotiation;
		},

		onAccessActionPOAddOrder: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getPOState(ctx.getParent());
			return state == this.poStateDraft || state == this.poStateNegotiation;
		},

		onAccessActionPOAddOrder2: function(/*Context*/ctx, /*Action*/action) {
			var poProduct = ctx.getParent();
			var po = ctx.cache.getNode(poProduct.PO, true);
			var state = this.getPOState(po);
			return state == this.poStateDraft || state == this.poStateNegotiation;
		},

		onAccessActionDeleteSiteLevelPurchasedOrder: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getPOState(ctx.getNode());
			return state == this.poStateDraft || state == this.poStateAbandoned;
		},

		onAccessActionNewPOLevelShipmentTerms: function(/*Context*/ctx, /*Action*/action) {
			var config = reflection.getObject(this.CONFIG);
			var po = ctx.getParent();
			return (config.Mode == "ShipmentMode:POLineItems") && (!config.OneShipmentsPerPO || (config.AllowSharedShipmentsPerPO && !po.ShipmentTerms.length));
		},

		onAccessActionSelectPOLevelShipmentTerms: function(/*Context*/ctx, /*Action*/action) {
			var config = reflection.getObject(this.CONFIG);
			var po = ctx.getParent();
			return (config.Mode == "ShipmentMode:POLineItems") && (config.AllowSharedShipmentsPerPO && !(config.OneShipmentsPerPO && po.ShipmentTerms.length));
		},

		onAccessActionNewSiteLevelShipmentTerms: function(/*Context*/ctx, /*Action*/action) {
			var config = reflection.getObject(this.CONFIG);
			return config.Mode == "ShipmentMode:Product" || config.AllowSharedShipmentsPerPO;
		},

		onAccessActionDeleteSiteLevelShipmentTerms: function(/*Context*/ctx, /*Action*/action) {
			return this.onAccessActionNewSiteLevelShipmentTerms(ctx, action);
		},

		onAccessActionNewShipment: function(/*Context*/ctx, /*Action*/action) {
			var config = reflection.getObject(this.CONFIG);
			return config.OneShipmentsPerPO || config.AllowSharedShipmentsPerPO;
		},

		canAggregateOrder: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: disable selection of dividers
			return ctx.getNode().$Type == "Order";
		},

		getPOState: function(po) {
			return xml.enumGetText(po.State);
		},

		orderQuoteUnapproved: function(poState, quoteState) {
			return array.indexOf(['PurchasedOrderState:Draft', 'PurchasedOrderState:Negotiation', 'PurchasedOrderState:Ready'], poState) != -1
				&& array.indexOf(['Revision.State:DRAFT', 'Revision.State:PENDING'], quoteState) != -1;
		},

		orderQuoteDeadEnd: function(poState, quoteState) {
			return array.indexOf(['PurchasedOrderState:Draft', 'PurchasedOrderState:Negotiation', 'PurchasedOrderState:Ready'], poState) != -1
				&& array.indexOf(['Revision.State:CLOSED', 'Revision.State:ABANDONED'], quoteState) != -1;
		},

		postActionShipmentQuantity: function(ac) {
			var view = ac.widget.viewParent;
			if (view)
				view.cacheView.put(ac.getNode());
		},

		postActionChangeOrderCnt: function(ac) {
			var v = ac.widget.viewParent ? ac.widget.viewParent.getChildView("PurchasedOrderHeader") : null;
			if (v) {
				v.cacheView.put(ac.getNode());
				v.refreshWidget();
			}
		},

		hasPOApprovalPrivilege: function(/*Context*/ctx, /*Action*/action) {
			return crews.isInGlobalRoles(["WBS Admin", "Purchase Order Administrator"]);
		},

		poStateChangeHasWorkflow: function(config, id, currentState) {
			return ((id == "POToNegotiation" && currentState == "PurchasedOrderState:Draft" && config.POWorkflowNameDraftToNegotiation) ||
				(id == "POBackToNegotiation" && currentState == "PurchasedOrderState:Ready" && config.POWorkflowNameReadyToNegotiation) ||
				(id == "POBackToNegotiation" && currentState == "PurchasedOrderState:Issued" && config.POWorkflowNameIssuedToNegotiation) ||
				(id == "POToReady" && currentState == "PurchasedOrderState:Negotiation" && config.POWorkflowNameNegotiationToReady) ||
				(id == "POToReady" && currentState == "PurchasedOrderState:Draft" && config.POWorkflowNameDraftToReady) ||
				(id == "POToIssued" && currentState == "PurchasedOrderState:Ready" && config.POWorkflowNameReadyToIssued) ||
				(id == "POToClosed" && currentState == "PurchasedOrderState:Issued" && config.POWorkflowNameIssuedToClosed));
		},

		isPOPackList() {
			const config = reflection.getObject(this.CONFIG);
			return config.AllowSharedShipmentsPerPO && config.OnePackListPerPO;
		},

		isNotPOPackList() {
			return !this.isPOPackList();
		}
	};
});